var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f57f21;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.344,1.172a1.172,1.172,0,0,0-2.344,0V2.5h2.344Z",
    transform: "translate(-56.234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.344,1.172a1.172,1.172,0,0,0-2.344,0V2.5h2.344Z",
    transform: "translate(-139.203)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M243.344,1.172a1.172,1.172,0,0,0-2.344,0V2.5h2.344Z",
    transform: "translate(-222.172)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M333.344,1.172a1.172,1.172,0,0,0-2.344,0V2.5h2.344Z",
    transform: "translate(-305.141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M423.344,1.172a1.172,1.172,0,0,0-2.344,0V2.5h2.344Z",
    transform: "translate(-388.109)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M361,381h2.344v2.344H361Z",
    transform: "translate(-332.797 -351.234)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,381h2.344v2.344H241Z",
    transform: "translate(-222.172 -351.234)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121,262h2.344v2.344H121Z",
    transform: "translate(-111.547 -241.531)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.828,32H35.234v3.516a1.172,1.172,0,0,1-2.344,0V32H28.2v3.516a1.172,1.172,0,1,1-2.344,0V32H21.172v3.516a1.172,1.172,0,0,1-2.344,0V32H14.141v3.516a1.172,1.172,0,1,1-2.344,0V32H7.109v3.516a1.172,1.172,0,1,1-2.344,0V32H1.172A1.172,1.172,0,0,0,0,33.172v7.422H40V33.172A1.172,1.172,0,0,0,38.828,32Z",
    transform: "translate(0 -29.5)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241,262h2.344v2.344H241Z",
    transform: "translate(-222.172 -241.531)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M361,262h2.344v2.344H361Z",
    transform: "translate(-332.797 -241.531)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,197.391a1.172,1.172,0,0,0,1.172,1.172H38.828A1.172,1.172,0,0,0,40,197.391V172H0Zm25.859-19.531a1.172,1.172,0,0,1,1.172-1.172h4.688a1.172,1.172,0,0,1,1.172,1.172v4.688a1.172,1.172,0,0,1-1.172,1.172H27.031a1.172,1.172,0,0,1-1.172-1.172Zm0,9.3a1.172,1.172,0,0,1,1.172-1.172h4.688a1.172,1.172,0,0,1,1.172,1.172v4.688a1.172,1.172,0,0,1-1.172,1.172H27.031a1.172,1.172,0,0,1-1.172-1.172Zm-9.375-9.3a1.172,1.172,0,0,1,1.172-1.172h4.688a1.172,1.172,0,0,1,1.172,1.172v4.688a1.172,1.172,0,0,1-1.172,1.172H17.656a1.172,1.172,0,0,1-1.172-1.172Zm0,9.3a1.172,1.172,0,0,1,1.172-1.172h4.688a1.172,1.172,0,0,1,1.172,1.172v4.688a1.172,1.172,0,0,1-1.172,1.172H17.656a1.172,1.172,0,0,1-1.172-1.172Zm-9.375-9.3a1.172,1.172,0,0,1,1.172-1.172h4.688a1.172,1.172,0,0,1,1.172,1.172v4.688a1.172,1.172,0,0,1-1.172,1.172H8.281a1.172,1.172,0,0,1-1.172-1.172Zm.266,11.96a1.172,1.172,0,0,1,1.649-.163l.653.535,2.383-2.931a1.172,1.172,0,1,1,1.819,1.479l-3.125,3.844a1.172,1.172,0,0,1-1.652.167l-1.563-1.281a1.172,1.172,0,0,1-.163-1.649Z",
    transform: "translate(0 -158.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.b0558959.svg";
export { ForwardRef as ReactComponent };